import { Pipe, PipeTransform } from '@angular/core';
import MarkdownIt from 'markdown-it';

/**
 * Markdown d'une anomalie (RG-anomalie-markdown-sans-html) : gras, italique, listes et liens,
 * rien d'autre. Le HTML brut est échappé (`html: false`), les liens `javascript:` et `data:` sont
 * refusés par markdown-it, et chaque lien s'ouvre dans un nouvel onglet. Le résultat passe encore
 * par l'assainissement d'Angular quand il est lié par `[innerHTML]`.
 */
const markdown = new MarkdownIt('zero', { html: false, linkify: true, breaks: true }).enable([
  'list',
  'emphasis',
  'link',
  'autolink',
  'linkify',
  'newline',
  'escape',
  'entity',
]);

const renderLinkOpen = markdown.renderer.rules['link_open'];
markdown.renderer.rules['link_open'] = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet('target', '_blank');
  tokens[idx].attrSet('rel', 'noopener noreferrer');
  return renderLinkOpen
    ? renderLinkOpen(tokens, idx, options, env, self)
    : self.renderToken(tokens, idx, options);
};

export function renderAnomalyMarkdown(content: string): string {
  return markdown.render(content);
}

@Pipe({ name: 'anomalyMarkdown' })
export class AnomalyMarkdownPipe implements PipeTransform {
  transform(content: string | null | undefined): string {
    return content ? renderAnomalyMarkdown(content) : '';
  }
}
